import {
  DO_EXEMPTED_ZIPCODES,
  GUARANTEE_LIMIT_EXEMPTION_THRESHOLD as DO_GUARANTEE_LIMIT_EXEMPTION_THRESHOLD,
  TURNOVER_EXEMPTION_THRESHOLD as DO_TURNOVER_EXEMPTION_THRESHOLD
} from './doFields';
import {
  MRIWK_BUILDING_TYPES_EXEMPTION,
  MRIWK_CLAIM_AMOUNT_EXEMPTION_THRESHOLD,
  MRIWK_FURNITURE_GUARANTEE_EXEMPTION_LIMIT,
  MRIWK_IGH_IGS_EXEMPTION_VALUES,
  MRIWK_MRI_SURFACE_EXEMPTION_LIMIT_MAX,
  MRIWK_MRI_SURFACE_EXEMPTION_LIMIT_MIN,
  MRIWK_OFFICE_ACTIVITY_PERCENTAGE_EXEMPTION,
  MRIWK_PNO_SURFACE_EXEMPTION_LIMIT_MAX,
  MRIWK_PNO_SURFACE_EXEMPTION_LIMIT_MIN,
  MRIWK_SHOP_ACTIVITY_PERCENTAGE_EXEMPTION,
  MRIWK_PROPERTY_NATURE_EXEMPTION_VALUES,
  isWKMri,
  isWKPno,
  MRIWK_BUILDING_COUNT_EXEMPTION_LIMIT,
  MRIWK_FURNISHED_EXEMPTION_VALUES,
  MRIWK_DEDUCTIBLE_AMOUNT_RATIO_EXEMPTION_VALUES,
  MRIWK_CLAIM_NUMBER_EXEMPTION_THRESHOLD,
  MRIWK_SUBSCRIBER_TYPE_EXEMPTION_VALUES,
  MRIWK_SHOP_AND_OFFICE_ACTIVITY_PERCENTAGE_EXEMPTION
} from './mriwkFields';
import {
  RCPMK_EXEMPTED_ZIPCODES,
  RCPMK_GUARANTEE_LIMIT_EXEMPTION_THRESHOLD,
  RCPMK_TURNOVER_EXEMPTION_THRESHOLD
} from './rcpmkFields';

import {
  getRCPHXTurnoverExemptionThreshold,
  RCPHX_GUARANTEE_LIMIT_EXEMPTION_THRESHOLD,
  RCPHX_GUARANTEE_LIMIT_EXEMPTION_THRESHOLD_MAX_SECU,
  RCPHX_GUARANTEE_LIMIT_EXEMPTION_THRESHOLD_MIN_TAG,
  RCPHX_TATOO_ACTIVITY,
  RCPHX_BIE_TATOO_ACTIVITY,
  RCPHX_TUNROVER_EXEMPTION_THRESHOLD_MAX_SECU,
  RCPHX_WORLDWIDE_ALLOWED_ACTIVITIES,
  includesBorlooActivity,
  includesVtmActivity
} from './rcphxFields';

import { getRCGLSTurnoverExemptionThreshold } from './rcglsFields';

import { isMetropolitanZipcode } from '../../utils/zipcode';
import { _ } from 'numeral';

export const EXCLUSION_EXEMPTION_ITEM = 'exclusion';

export const exemptionsValues = {
  rcp: {
    turnover: (
      value,
      initialContractValues,
      formValues,
      codesNaf,
      supplier
    ) => {
      if (supplier === 'cm') {
        return value > 1000000;
      }
      if (supplier === 'ml') {
        return value > 750000;
      }
      return value > 500000;
    },
    employees_number: (value) => {
      return value > 20;
    },
    guarantee_limit: (value, initialContractValues, _, __, supplier) => {
      if (supplier === 'wk' || supplier === 'cm') {
        return value > 999999 || value > initialContractValues;
      }
      return value > 300000 || value > initialContractValues;
    },
    deductible_amount: (
      value,
      initialContractValues,
      formValues,
      codesNaf,
      supplier
    ) => {
      let miniDeductibleAmount = 0;
      const maxDeductibleAmount = supplier === 'ml' ? 2000 : 1000;
      const selectedActivities = (formValues.activities || []).map(
        (a) => a.split(' - ')[0]
      );
      selectedActivities.forEach((activityName) => {
        const activity = codesNaf?.find((act) => act.name === activityName);
        if (activity?.mini_deductible_amount > miniDeductibleAmount) {
          miniDeductibleAmount = activity?.mini_deductible_amount;
        }
      });
      return (
        value < miniDeductibleAmount ||
        value > maxDeductibleAmount ||
        value < initialContractValues
      );
    },
    number_claims: (value) => value > 1,
    claim_amount: (value, initialContractValues) =>
      value >= 1500 || initialContractValues < value,
    termination_reason_by_company: (value) =>
      value && value !== 'TERMINATION_NO_PAYMENT',
    termination_claims: (value) => value,
    termination_legal_redress: (value) => value,
    termination_judicial_liquidation: (value) => value,
    termination_other: (value) => value,
    straw_rubber_activity: (value) => value,
    industrial_activity: (value) => value,
    metropolitan_france: (value) => !value,
    religious_pol: (value) => value,
    surface_area: (value, initialContractValues) =>
      value > initialContractValues,
    sworn_statement: (value) => !value,
    combustible_packaging: (value) => value,
    wholesale_business: (value) => value,
    france_with_corsica: (value) => !value,
    industrial_straw_activity: (value) => value,
    construction_activity: (value) => value,
    medical_activity: (value) => value,
    is_in_liquidation_or_receivership: (value) => value,
    legal_activity: (value) => value,
    has_already_been_terminated_by_asx: (value) => value
  },
  rcpmk: {
    turnover: (value) => value >= RCPMK_TURNOVER_EXEMPTION_THRESHOLD,
    guarantee_limit: (value) =>
      value >= RCPMK_GUARANTEE_LIMIT_EXEMPTION_THRESHOLD,
    it_forbidden_activities: (value, _, formValues) =>
      !value && formValues?.activity_type === 'IT',
    it_regulated_activities: (value, _, formValues) =>
      !value && formValues?.activity_type === 'IT',
    media_forbidden_activities: (value, _, formValues) =>
      !value && formValues?.activity_type === 'MEDIA',
    service_forbidden_activities_one: (value, _, formValues) =>
      !value && formValues?.activity_type === 'SERVICE',
    service_forbidden_activities_two: (value, _, formValues) =>
      !value && formValues?.activity_type === 'SERVICE',
    service_forbidden_activities_three: (value, _, formValues) =>
      !value && formValues?.activity_type === 'SERVICE',
    consulting_forbidden_activities: (value, _, formValues) =>
      !value && formValues?.activity_type === 'CONSULTING',
    managment_protection_prerequisite: (value, _, formValues) =>
      !value && !!formValues?.management_protection,
    cyber_protection_prerequisite: (value, _, formValues) =>
      !value && !!formValues?.cyber_events_protection,
    merge_protection_prerequisite: (value, _, formValues) =>
      !value && !!formValues?.merge_protection,
    etablishment_outside_france: (value) => !value,
    limited_turnover_in_usa: (value) => !value,
    limited_claims_indemnity: (value) => !value,
    current_claim: (value) => !value,
    customer: (value) => {
      const exemptionObj = {
        postal_code: false
      };

      const { address } = value || {};
      const { postal_code } = address || {};

      if (RCPMK_EXEMPTED_ZIPCODES.includes(postal_code)) {
        exemptionObj.postal_code = true;
      }

      return exemptionObj;
    }
  },
  rcphx: {
    turnover: (
      value,
      initialContractValues,
      formValues,
      codesNaf,
      supplier,
      estimation,
      activitiesHiscox
    ) => {
      if (
        value >=
        getRCPHXTurnoverExemptionThreshold(
          activitiesHiscox,
          formValues.activity_type,
          formValues.activity_detail,
          formValues.turnover,
          formValues.guarantee_limit
        )
      ) {
        return true;
      }
      if (
        formValues.activity_type === 'SECU' &&
        formValues.turnover > RCPHX_TUNROVER_EXEMPTION_THRESHOLD_MAX_SECU
      ) {
        return true;
      }
      return false;
    },
    guarantee_limit: (value, _, formValues) => {
      // MED / OSTEO have a fixed 8M€ LOI forced by the system, not a broker-chosen
      // capital, so it must never trigger the generic dérogation threshold
      if (['MED', 'OSTEO', 'BIE'].includes(formValues.activity_type)) {
        return false;
      }
      if (value >= RCPHX_GUARANTEE_LIMIT_EXEMPTION_THRESHOLD) {
        return true;
      }
      if (
        formValues.activity_type === 'TAG' &&
        value <= RCPHX_GUARANTEE_LIMIT_EXEMPTION_THRESHOLD_MIN_TAG
      ) {
        return true;
      }
      if (
        formValues.activity_type === 'SECU' &&
        value > RCPHX_GUARANTEE_LIMIT_EXEMPTION_THRESHOLD_MAX_SECU
      ) {
        return true;
      }
      return false;
    },
    activity_detail: (value) => value,
    turnover_usa_canada: (
      hasTurnoverUsaCanada,
      initialContractValues,
      formValues
    ) => {
      if (
        hasTurnoverUsaCanada &&
        !RCPHX_WORLDWIDE_ALLOWED_ACTIVITIES.includes(formValues?.activity_type)
      ) {
        return true;
      }
      if (hasTurnoverUsaCanada) {
        const {
          turnover_usa_canada_amount,
          turnover,
          turnover_usa_canada_amount_type
        } = formValues;
        if (turnover_usa_canada_amount_type === 'PERCENTAGE') {
          return turnover_usa_canada_amount > 30;
        }
        return turnover_usa_canada_amount > 0.3 * turnover;
      }
      return false;
    },
    // pre requisite
    geographic_exposure_hiscox: (value) => !!value,
    geographic_exposure_hiscox_world: (value) => !!value,
    insurance_historic_hiscox: (value) => !!value,

    activity_hiscox_tech: (value, _, formValues) =>
      formValues?.activity_type === 'TECH' &&
      !formValues?.turnover_usa_canada &&
      !!value,
    activity_hiscox_tech_world: (value, _, formValues) =>
      formValues?.activity_type === 'TECH' &&
      formValues?.turnover_usa_canada &&
      !!value,
    activity_hiscox_tech_ia: (value, _, formValues) =>
      formValues?.activity_type === 'TECH' &&
      (formValues?.turnover || 0) > 1_000_000 &&
      !!value,
    activity_hiscox_mac: (value, _, formValues) =>
      formValues?.activity_type === 'MAC' &&
      !formValues?.turnover_usa_canada &&
      !!value,
    activity_hiscox_mac_world: (value, _, formValues) =>
      formValues?.activity_type === 'MAC' &&
      formValues?.turnover_usa_canada &&
      !!value,
    activity_hiscox_man: (value, _, formValues) =>
      formValues?.activity_type === 'MAN' &&
      !formValues?.turnover_usa_canada &&
      !!value,
    activity_hiscox_man_world: (value, _, formValues) =>
      formValues?.activity_type === 'MAN' &&
      formValues?.turnover_usa_canada &&
      !!value,
    activity_hiscox_med: (value, _, formValues) =>
      formValues?.activity_type === 'MEDIA' &&
      !formValues?.turnover_usa_canada &&
      !!value,
    activity_hiscox_med_world: (value, _, formValues) =>
      formValues?.activity_type === 'MEDIA' &&
      formValues?.turnover_usa_canada &&
      !!value,
    activity_hiscox_misc: (value, _, formValues) =>
      formValues?.activity_type === 'MISC' && !!value,
    activity_transport_misc: (value, _, formValues) =>
      formValues?.activity_type === 'MISC' &&
      includesVtmActivity(formValues?.activity_detail) &&
      !!value,
    activity_borloo_misc: (value, _, formValues) =>
      formValues?.activity_type === 'MISC' &&
      includesBorlooActivity(formValues?.activity_detail) &&
      !!value,
    activity_hiscox_misc_tattoo: (value, _, formValues) =>
      formValues?.activity_type === 'MISC' &&
      formValues?.activity_detail?.includes(RCPHX_TATOO_ACTIVITY) &&
      !!value,
    compliance_hiscox_misc_tattoo: (value, _, formValues) =>
      formValues?.activity_type === 'MISC' &&
      formValues?.activity_detail?.includes(RCPHX_TATOO_ACTIVITY) &&
      !!value,
    activity_hiscox_tag: (value, _, formValues) =>
      formValues?.activity_type === 'TAG' &&
      !formValues?.turnover_usa_canada &&
      !!value,
    activity_hiscox_tag_world: (value, _, formValues) =>
      formValues?.activity_type === 'TAG' &&
      formValues?.turnover_usa_canada &&
      !!value,
    activity_hiscox_secu: (value, _, formValues) =>
      formValues?.activity_type === 'SECU' && !!value,
    activity_hiscox_bie: (value, _, formValues) =>
      formValues?.activity_type === 'BIE' && !!value,
    activity_hiscox_bie_pregnants: (value, _, formValues) =>
      formValues?.activity_type === 'BIE' && !!value,
    activity_hiscox_bie_pregnants_manipulation: (value, _, formValues) =>
      formValues?.activity_type === 'BIE' && !!value,
    activity_hiscox_bie_children: (value, _, formValues) =>
      formValues?.activity_type === 'BIE' && !!value,
    activity_hiscox_bie_qualification: (value, _, formValues) =>
      formValues?.activity_type === 'BIE' &&
      !formValues?.activity_detail?.includes(RCPHX_BIE_TATOO_ACTIVITY) &&
      !!value,
    activity_hiscox_bie_sport: (value, _, formValues) =>
      formValues?.activity_type === 'BIE' && !!value,
    activity_hiscox_bie_tattoo_eligibility: (value, _, formValues) =>
      formValues?.activity_type === 'BIE' &&
      formValues?.activity_detail?.includes(RCPHX_BIE_TATOO_ACTIVITY) &&
      !!value,
    activity_hiscox_bie_tattoo: (value, _, formValues) =>
      formValues?.activity_type === 'BIE' &&
      formValues?.activity_detail?.includes(RCPHX_BIE_TATOO_ACTIVITY) &&
      !!value,
    compliance_hiscox_bie_tattoo: (value, _, formValues) =>
      formValues?.activity_type === 'BIE' &&
      formValues?.activity_detail?.includes(RCPHX_BIE_TATOO_ACTIVITY) &&
      !!value,
    activity_hiscox_med_paramedical: (value, _, formValues) =>
      formValues?.activity_type === 'MED' && !!value,
    activity_hiscox_osteo: (value, _, formValues) =>
      formValues?.activity_type === 'OSTEO' && !!value,
    activity_hiscox_cyber: (value, _, formValues) =>
      !!formValues?.cyber_option_rcphx && !!value,
    history_cyber_hiscox: (value, _, formValues) =>
      !!formValues?.cyber_option_rcphx && !!value,
    geographic_exposure_hiscox_cyber: (value, _, formValues) =>
      !!formValues?.cyber_option_rcphx && !!value,
    history_risk_hiscox: (value) => !!value
  },
  rcgls: {
    turnover: (value, _, formValues) => {
      if (
        value > getRCGLSTurnoverExemptionThreshold(formValues.main_activity)
      ) {
        return true;
      }
      return false;
    },
    sworn_statement: (value) => !value,
    no_activity_usa_canada: (value) => !value,
    not_listed_in_eu_sanctions: (value) => !value,
    accurate_and_truthful_declarations: (value) => !value,
    report_change_of_situation: (value) => !value,
    no_acpr_sanctions: (value) => !value,
    no_foreign_branch_or_subsidiary: (value) => !value,
    no_problems_last_5_years: (value) => !value,
    no_known_risk_facts: (value) => !value,
    orias_required_for_guarantee: (value) => !value,
    registration_required_for_guarantee: (value) => !value,
    already_resiliated_by_assurmax: (value) => value,
    legal_and_regulatory_compliance: (value) => !value,
    multiple_principals: (value) => !value,
    registered_commercial_agent: (value) => !value,
    in_process_cci: (value) => !value,
    no_financial_engineering: (value) => !value,
    real_estate_tax_reduction_activity: (value) => !value,
    no_asset_management_for_third_parties: (value) => !value,
    no_miscellaneous_goods_intermediation: (value) => !value,
    no_gestion_patrimoine_without_cif: (value) => !value,
    mandataires_to_cover: (value) => value,
    orias_compliance_insurance: (value) => !value,
    accessory_activity_ia_mia_dfb: (value) => value,
    accessory_activity_ia_mia: (value) => value,
    accessory_activity_dfb: (value) => value,
    delegation_or_mandate: (value) => value,
    wants_financial_guarantee: (value) => value,
    accounts_verified_by_accountant: (value) => !value,
    accounts_verified_by_accountant_mia: (value) => !value,
    mandataires_to_cover_mias: (value) => value,
    no_risky_insurance_contexts: (value) => !value,
    reinsurance_broker: (value) => value,
    orias_compliance_assurance: (value) => !value,
    accessory_activity_iobsp_dfb_cif: (value) => value,
    accessory_activity_iobsp: (value) => value,
    accessory_activity_dfb_again: (value) => value,
    accessory_activity_cif: (value) => value,
    no_foreign_branch: (value) => !value,
    no_property_management_activity: (value) => !value,
    real_estate_tax_reduction_activity_ai: (value) => value,
    wants_financial_guarantee_no_funds: (value) => value,
    accessory_activity_ia_mia_or_iobsp_miobsp: (value) => value,
    accessory_activity_ia_mia_alt: (value) => value,
    accessory_activity_iobsp_miobsp: (value) => value,
    single_mandate_insurance: (value) => !value,
    single_mandate_iobsp: (value) => !value,
    orias_compliance_miobsp: (value) => !value,
    orias_compliance_bank: (value) => !value,
    risky_mandant_relationships: (value) => value,
    maritime_insurance: (value) => value,
    construction_insurance: (value) => value,
    construction_insurance_company_check: (value) => !value,
    construction_project_check: (value) => value,
    only_france_based_clients: (value) => !value,
    no_us_canada_bank_activity: (value) => !value
  },
  association: {
    turnover: (value) => value > 30000,
    employees_number: (value, initialContractValues) =>
      value > 50 || value > initialContractValues,
    representatives_number: (value, initialContractValues) =>
      value > 20 || value > initialContractValues,
    total_members: (value, initialContractValues) =>
      value > 200 || value > initialContractValues,
    yearly_events: (value) => value === 'MORE_THAN_12',
    participants_per_event: (value) => value === 'MORE_THAN_700',
    guarantee_limit: (value, initialContractValues) =>
      value > 500000 || value > initialContractValues,
    number_claims: (value) => value > 2,
    claim_amount: (value, initialContractValues) =>
      value >= 1500 || initialContractValues < value,
    termination_reason_by_company: (value) =>
      value && value !== 'TERMINATION_NO_PAYMENT',
    termination_claims: (value) => value,
    termination_legal_redress: (value) => value,
    termination_judicial_liquidation: (value) => value,
    termination_other: (value) => value,
    straw_rubber_activity: (value) => value,
    industrial_activity: (value) => value,
    metropolitan_france: (value) => !value,
    take_care_building: (value) => !value,
    political_activity: (value) => value,
    max_claims: (value) => value,
    no_claims: (value) => value,
    confirm_claims: (value) => !value,
    annual_budget: (value) => value,
    extinguisher_conformed: (value) => !value,
    religious_pol: (value) => value,
    surface_area: (value, initialContractValues) =>
      value > initialContractValues,
    sworn_statement: (value) => !value,
    PACKAGE_1: () => false,
    fire_explosion_attack_climatic_event: (value) => value > 50000,
    theft_vandalism: (value) => value > 30000,
    water_damage: (value) => value > 50000,
    broken_windows: (value) => value > 10000,
    broken_machine: (value) => value > 10000,
    electric_damage: (value) => value > 10000,
    chilled_merchandise: (value) => value > 2000,
    litigation_responsibility: (value) => value,
    blocked_activities: (value) => value,
    mall: (value) => value,
    is_a_palace: (value) => value,
    monument: (value) => value,
    closed_more_60_days: (value) => value,
    embassy_bowling_disco: (value) => value,
    industry_less_10m: (value) => value,
    close_help: (value) => !value,
    altitude_location: (value) => !value,
    renovation: (value) => value,
    disaffected: (value) => value,
    zone_ind_com_art: (value) => value,
    had_waived_certain_remedies_in_its_lease: (value) => value,
    built_covered_hard_materials: (value) => !value,
    electric_conformed: (value) => !value,
    restaurant_activity: (value) => !value,
    close_before_2300: (value) => !value,
    chilled_products_conformed: (value) => !value,
    sites: (value, _, formValues, codesNaf) => {
      let surface = 0;
      let postcodesWithExemption;
      value.forEach((s) => {
        surface += s?.surface_area || 0;
        if (s?.address?.postal_code && codesNaf) {
          const selectedActivities = (formValues.activities || []).map(
            (a) => a.split(' - ')[0]
          );
          selectedActivities.forEach((activityName) => {
            const activity = codesNaf?.find((act) => act.name === activityName);
            if (
              activity?.exemption_postcode &&
              activity?.exemption_postcode.length
            ) {
              activity.exemption_postcode.forEach((postcode) => {
                if (s.address.postal_code.startsWith(postcode))
                  postcodesWithExemption = true;
              });
            }
          });
        }
      });
      return { surface: surface > 500, postcode: postcodesWithExemption };
    }
  },
  mriml: {
    // total_buildings: (value) => value > 10,
    total_buildings: (value) => value >= 0, // tmp update
    is_lci_of_x_million_sufficient: (value) => !value,
    risk_assured_location_outside_metropolitan_france: (value) => value,
    activity_in_qpv_area: (value) => value,
    risk_under_construction_or_90_percent_materials: (value) => value,
    risk_is_for_depollution_rehabilitation: (value) => value,
    fire_claim_last_60_months_subscriber_affiliates: (value) => value,
    risk_is_wooden_structure_or_wood_cladding: (value) => value,
    risk_is_contiguous_with_industrial_activity: (value) => value,
    proximity_of_building_to_risk_of_peril_in_marseille: (value) => value,
    risk_is_occupied_illegally: (value) => value,
    specific_risk: (value) => value && value !== 'NONE',
    risk_is_subject_to_alignment: (value) => value,
    risk_contains_inflammable_liquids: (value) => value,
    risk_is_above_1500m_and_inaccessible_by_rescue: (value) => value,
    presence_of_lease_with_waiver_of_recourse_clause: (value) => value,
    building_subject_to_major_works_or_renovation: (value) => value,
    risk_dedicated_to_demolition: (value) => value,
    establishments_receiving_public_category_1_to_4: (value) => value,
    establishments_receiving_public_category_5_closing_before_23h: (value) =>
      value,
    risk_involves_specific_high_risk_activities: (value) => value,
    risk_contains_asbestos_or_specific_roofing_materials: (value) => value,
    risk_under_judicial_administration: (value) => value,
    contains_asbestos_or_fibrocement: (value) => value,
    is_continuously_insured_since_acquisition: (value) => !value,
    roof_contains_non_standard_materials: (value) => value,
    policyholder_in_bankruptcy_or_liquidation: (value) => value,
    risk_is_vacant_land: (value) => value,
    risk_declared_contains_high_risk_activities_or_premises: (value) => value,
    risk_contains_religious_political_diplomatic_or_union_activity: (value) =>
      value,
    risk_declared_is_high_rise_or_large_real_estate_complex: (value) => value,
    risk_declared_is_a_castle: (value) => value,
    risk_declared_is_classified_or_listed_building: (value) => value,
    risk_is_an_unbuildable_land: (value) => value,
    risk_contains_cold_storage_above_120m3: (value) => value,
    risk_declared_is_in_flood_zone: (value) => value,
    risk_is_not_in_good_condition: (value) => value,
    will_property_be_renovated_in_4_months: (value) => value,
    will_property_be_renovated_in_more_than_4_months: (value) => value,
    risk_declared_under_unsanitary_or_dangerous_decree: (value) => value,
    surface_area: (value) => value > 2000,
    occupation_trade: (value) => value === 'plus_50',
    empty_unoccupied_works: (value) => value,
    deductible_cost_index: (value) => value === 'OTHER' || value === '0x',
    furniture_capital: (value) => value === 'OTHER',
    number_claims: (value) => value > 1,
    claim_amount: (value, initialContractValues) =>
      value >= 1600 || initialContractValues < value,
    termination_reason_by_company: (value) =>
      value && value !== 'TERMINATION_NO_PAYMENT',
    cat_nat_risk: (value) => value === 7,
    is_property_dealer: (value) => value
  },
  pnoml: {
    surface_area: (value) => value > 300,
    claim_amount: (value, initialContractValues) =>
      value >= 1600 || initialContractValues < value,
    tenant_in_restructuring_or_liquidation: (value) => value,
    property_under_construction_prerequisite: (value) => value,
    under_construction_duration: (value) =>
      value === 'under_construction_plus4',
    no_prohibited_activities_declared: (value) => value,
    property_in_renovation_over_4_months: (value) => value,
    property_in_historic_building: (value) => value,
    is_property_occupied_or_will_be_within_2_months: (value) => !value,
    have_you_owned_property_for_more_than_2_months: (value) => value,
    property_in_castle_or_listed_building: (value) => value,
    risk_has_prohibited_restaurant_activities: (value) => value,
    risk_has_industrial_activities: (value) => value
  },
  mri: {
    veranda: (value, initialContractValues) =>
      value === true && initialContractValues === false,
    hard_materials: (value) => !value,
    good_state: (value) => !value,
    altitude_location: (value) => !value,
    accessibility: (value) => !value,
    metropolitan_france: (value) => !value,
    activity_open_public: (value) => !value,
    castle_manor: (value) => value,
    contractual_general_indemnity_limit: (value) => !value,
    classified_listed: (value) => value,
    redress_liquidation: (value) => value,
    wooden_construction: (value) => value,
    temporary_activity: (value) => value,
    specific1_activities: (value) => value,
    religious_political_union: (value) => value,
    close_industrial_complex: (value) => value,
    specific2_activities: (value) => value,
    specific3_activities: (value) => value,
    waiver_recourse_against_tenants: (value) => value,
    cold_rooms_flammable_liquids: (value) => value,
    land_classified_non_constructible: (value) => value,
    building_height: (value) => value,
    risk_has_graffitis_or_tags: (value) => value,
    roof_non_standard_materials: (value) => value,
    agricultural_building: (value) => value,
    building_type: (value) =>
      value === 'NOOFGPRICING2_HOTEL' ||
      value === 'NOOFGPRICING2_PLACES_WORSHIP' ||
      value === 'NOOFGPRICING2_POLITICAL_OFFICE' ||
      value === 'OTHER',
    building_category: (value) => value === 'ATYPICAL',
    building_condition: (value) => value === 'DILAPIDATED',
    surface_area: (value) => value > 2000,
    occupation_trade: (value) => value === 'plus_50',
    empty_unoccupied_works: (value) => value,
    deductible_cost_index: (value) => value === 'OTHER' || value === '0x',
    administrative_area_level_2: (value) => value?.startsWith('13'),
    main_use: (value) => value === 'OTHER',
    total_buildings: (value) => value > 5,
    risk_typology: (value) => value === 'OTHER',
    furniture_capital: (value) => value === 'OTHER',
    number_claims: (value) => value > 1,
    claim_amount: (value, initialContractValues) =>
      value >= 1500 || initialContractValues < value,
    termination_reason_by_company: (value) =>
      value && value !== 'TERMINATION_NO_PAYMENT',
    sworn_statement: (value) => !value,
    cat_nat_risk: (value) => value === 7
  },
  mrp: {
    PACKAGE_1: () => false,
    PACKAGE_2: () => false,
    PACKAGE_3: () => false,
    fire_explosion_attack_climatic_event: (value) => value > 100000,
    theft_vandalism: (value) => value > 100000,
    water_damage: (value) => value > 100000,
    broken_windows: (value) => value > 20000,
    broken_machine: (value) => value > 20000,
    electric_damage: (value) => value > 20000,
    external_furniture: (value) => value > 8000,
    chilled_merchandise: (value) => value > 8000,
    rc_pro_guarantee: (
      value,
      initialContractValues,
      formValues,
      codesNaf,
      supplier
    ) => {
      if (supplier === 'ml') {
        return value > 300000;
      }
      return value > 600000;
    },
    turnover: (
      value,
      initialContractValues,
      formValues,
      codesNaf,
      supplier
    ) => {
      if (supplier === 'cm') {
        return value > 1000000;
      }
      if (supplier === 'ml') {
        return value > 750000;
      }
      return value > 500000;
    },
    furniture_capital: (value) => value > 100000,
    '75percent_tough_materials': (value) => !value,
    '90percent_tough_materials': (value) => !value,
    '2_incidents_max': (value) => !value,
    '28m_high': (value) => value,
    employees_number: (value) => {
      return value > 20;
    },
    cat_nat_risk: (value) => value === 7,
    take_care_building: (value) => !value,
    more_500m_altitude: (value) => !value,
    close_help: (value) => !value,
    castle: (value) => value,
    monument: (
      value,
      initialContractValues,
      formValues,
      codesNaf,
      supplier
    ) => {
      if (supplier === 'wk') {
        return false;
      }
      return value;
    },
    liquidation: (value) => value,
    is_in_liquidation_or_receivership: (value) => value,
    ffb_1000_times: (value) => value,
    mall: (value) => value,
    mall_big: (value) => value,
    embassy_bowling_disco: (value) => value,
    religious_political: (value) => value,
    industry_less_10m: (value) => value,
    wood_plastic_nuclear_activity: (value) => value,
    straw_rubber_stock: (value) => value,
    disaffected: (value) => value,
    tags_roof_materials: (value) => value,
    risk_has_graffitis_or_tags: (value) => value,
    roof_non_standard_materials: (value) => value,
    roof_is_flat_or_terrace: (value) => value,
    walking_cooler: (value) => value,
    renovation: (value) => value,
    extinguisher_conformed: (value) => !value,
    sea_side: (value) => value,
    combustible_packaging: (value) => value,
    industrial_straw_activity: (value) => value,
    construction_activity: (value) => value,
    wholesale_business: (value) => value,
    fire_claim_last_60_months_subscriber_affiliates: (value) => value,
    electric_conformed: (value) => !value,
    restaurant_activity: (value) => !value,
    metropolitan_france: (value) => !value,
    chilled_products_conformed: (value) => !value,
    number_claims: (value) => value > 1,
    claim_amount: (value, initialContractValues) =>
      value >= 1500 || initialContractValues < value,
    termination_reason_by_company: (value) =>
      value && value !== 'TERMINATION_NO_PAYMENT',
    sworn_statement: (value) => !value,
    deductible_amount: (
      value,
      initialContractValues,
      formValues,
      codesNaf,
      supplier
    ) => {
      const maxDeductibleAmount = supplier === 'ml' ? 2000 : 1000;
      let miniDeductibleAmount = 0;
      const selectedActivities = (formValues.activities || []).map(
        (a) => a.split(' - ')[0]
      );
      selectedActivities.forEach((activityName) => {
        const activity = codesNaf?.find((act) => act.name === activityName);
        if (activity?.mini_deductible_amount > miniDeductibleAmount) {
          miniDeductibleAmount = activity?.mini_deductible_amount;
        }
      });
      return (
        value < miniDeductibleAmount ||
        value > maxDeductibleAmount ||
        value < initialContractValues
      );
    },
    sites: (value, _, formValues, codesNaf, supplier) => {
      let surface = 0;
      let postcodesWithExemption = false;
      let postcodesWithExclusion = false;
      value.forEach((s) => {
        surface += s?.surface_area || 0;
        const sitePostalCode = s?.address?.postal_code || '';
        if (sitePostalCode && codesNaf) {
          const selectedActivities = (formValues.activities || []).map(
            (a) => a.split(' - ')[0]
          );
          selectedActivities.forEach((activityName) => {
            const activity = codesNaf?.find((act) => act.name === activityName);
            if (
              activity?.exemption_postcode &&
              activity?.exemption_postcode.length
            ) {
              activity.exemption_postcode.forEach((postcode) => {
                if (sitePostalCode.startsWith(postcode))
                  postcodesWithExemption = true;
              });
            }

            const excluded_postcode = activity?.excluded_postcode || [];
            postcodesWithExclusion =
              postcodesWithExclusion ||
              excluded_postcode.some((postcode) =>
                sitePostalCode.startsWith(postcode)
              );
          });
        }
      });
      return {
        surface: surface > 500 || (surface > 400 && supplier !== 'ml'),
        postcode: postcodesWithExemption,
        exclusion: postcodesWithExclusion
      };
    },
    business_loss_guarantee: (value) => value >= 18,
    market_value: (value) => value >= 120000,
    has_already_been_terminated_by_asx: (value) => value,
    localized_qpv: (value) => value,
    lci_sufficient: (value) => !value,
    half_timbering_structure: (value) => value
  },
  prevoyance: {
    sworn_statement: (value) => !value
  },
  do: {
    turnover: (value) => value >= DO_TURNOVER_EXEMPTION_THRESHOLD,
    guarantee_limit: (value) => value >= DO_GUARANTEE_LIMIT_EXEMPTION_THRESHOLD,
    max_tax_result: (value) => !value,
    metropolitan_france: (value) => !value,
    more_than_2_years: (value) => !value,
    no_merge_takeover: (value) => !value,
    stock_exchange_listing: (value) => !value,
    insolvency_proceeding: (value) => !value,
    positive_last_2_tax_result: (value) => !value,
    positive_last_2_equity: (value) => !value,
    last_5_years_blame: (value) => !value,
    sworn_statement: (value) => !value,
    holding_prerequisites: (value, _, formValues) =>
      !!formValues.holding_protection && !value,
    not_operate_in_forbidden_activities: (value) => !value,
    company_in_creation: (value) => value,
    customer: (value) => {
      const exemptionObj = {
        postal_code: false
      };

      const { address } = value || {};
      const { postal_code } = address || {};

      if (DO_EXEMPTED_ZIPCODES.includes(postal_code)) {
        exemptionObj.postal_code = true;
      }

      return exemptionObj;
    }
  },
  mriwk: {
    // PRICING
    address: (
      { city, postal_code },
      _initial,
      _values,
      _naf,
      _supplier,
      estimation
    ) =>
      !!city &&
      (!!estimation?.error?.cat_nat_risk ||
        !isMetropolitanZipcode(postal_code || '')),
    building_count: (value) => value >= MRIWK_BUILDING_COUNT_EXEMPTION_LIMIT,
    building_type: (value) => MRIWK_BUILDING_TYPES_EXEMPTION.includes(value),
    surface_area: (value, _, formValues) => {
      if (isWKPno(formValues)) {
        return (
          MRIWK_PNO_SURFACE_EXEMPTION_LIMIT_MIN > value ||
          value > MRIWK_PNO_SURFACE_EXEMPTION_LIMIT_MAX
        );
      }
      if (isWKMri(formValues)) {
        return (
          MRIWK_MRI_SURFACE_EXEMPTION_LIMIT_MIN > value ||
          value > MRIWK_MRI_SURFACE_EXEMPTION_LIMIT_MAX
        );
      }

      return false;
    },
    is_condominium: (value) => !value,
    is_vacant: (value) => value,
    office_activity_percentage: (
      value = 0,
      _,
      { shop_activity_percentage = 0 }
    ) =>
      value > MRIWK_OFFICE_ACTIVITY_PERCENTAGE_EXEMPTION ||
      value + shop_activity_percentage >
        MRIWK_SHOP_AND_OFFICE_ACTIVITY_PERCENTAGE_EXEMPTION,
    shop_activity_percentage: (
      value = 0,
      _,
      { office_activity_percentage = 0 }
    ) =>
      value > MRIWK_SHOP_ACTIVITY_PERCENTAGE_EXEMPTION ||
      value + office_activity_percentage >
        MRIWK_SHOP_AND_OFFICE_ACTIVITY_PERCENTAGE_EXEMPTION,
    furniture_guarantee: (value) =>
      value > MRIWK_FURNITURE_GUARANTEE_EXEMPTION_LIMIT,
    igh_igs: (value) => MRIWK_IGH_IGS_EXEMPTION_VALUES.includes(value),
    property_nature: (value) =>
      MRIWK_PROPERTY_NATURE_EXEMPTION_VALUES.includes(value),
    is_furnished: (value) => MRIWK_FURNISHED_EXEMPTION_VALUES.includes(value),
    deductible_amount_ratio: (value) =>
      MRIWK_DEDUCTIBLE_AMOUNT_RATIO_EXEMPTION_VALUES.includes(value),

    // PREREQUISITES
    hard_material_prerequisite: (value) => !value,
    good_state_prerequisite: (value) => !value,
    firefighting_water_prerequisite: (value) => !value,
    rescue_access_prerequisite: (value) => !value,
    metropolitan_france_prerequisite: (value) => !value,
    public_late_prerequisite: (value) => !value,
    is_asl_aful_prerequisite: (value) => !!value,
    fast_food_prerequisite: (value) => !!value,
    classified_prerequisite: (value) => !!value,
    monument_prerequisite: (value) => !!value,
    liquidation_prerequisite: (value) => !!value,
    temporary_activity_prerequisite: (value) => !!value,
    recreation_activity_prerequisite: (value) => !!value,
    political_activity_prerequisite: (value) => !!value,
    near_industrial_activity_prerequisite: (value) => !!value,
    industrial_activity_prerequisite: (value) => !!value,
    transformed_products_prerequisite: (value) => !!value,
    waiver_clause_prerequisite: (value) => !!value,
    cold_room_prerequisite: (value) => !!value,
    unbuildable_prerequisite: (value) => !!value,
    roof_prerequisite: (value) => !!value,
    agricultural_building_prerequisite: (value) => !!value,
    igh_igs_prerequisite: (value) => !!value,
    wood_floor_prerequisite: (value) => !!value,
    peril_prerequisite: (value) => !!value,
    vacant_prequisite: (value) => !!value,
    demolition_prerequisite: (value) => !!value,
    zup_prerequisite: (value) => !!value,
    flooding_prerequisite: (value) => !!value,
    condominium_surface_prerequisite: (value) => !!value,

    // ANTECEDENTS
    number_claims: (value) => value > MRIWK_CLAIM_NUMBER_EXEMPTION_THRESHOLD,
    claim_amount: (value) => value > MRIWK_CLAIM_AMOUNT_EXEMPTION_THRESHOLD,

    // SUBSCRIBER
    subscriber_type: (value, _, formValues = {}) => {
      const { subscriber = 'LEGAL_PERSON' } = formValues;

      if (
        subscriber === 'LEGAL_ENTITY' &&
        MRIWK_SUBSCRIBER_TYPE_EXEMPTION_VALUES.includes(value)
      ) {
        return true;
      }

      return false;
    }
  }
};

const checkExemption = ({
  type,
  values,
  initialContractValues,
  codesNaf,
  supplier,
  estimation = null,
  errorGetCities,
  errorGetQPV,
  isQPV = false,
  activitiesHiscox = []
}) => {
  const exemptionFields = [];

  Object.entries(values).forEach(([fieldName, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (
          fieldName === 'buildings' &&
          exemptionsValues[type]?.administrative_area_level_2 &&
          exemptionsValues[type]?.administrative_area_level_2(
            v?.address?.postal_code
          )
        ) {
          exemptionFields.push(`administrative_area_level_2`);
        }
        if (
          fieldName === 'claims' &&
          exemptionsValues[type]?.claim_amount(v.claim_amount)
        ) {
          exemptionFields.push(`claim_amount`);
        }
      });
      if (fieldName === 'sites') {
        if (value.length > 1 && type === 'association')
          exemptionFields.push('number_sites');
        if (value.length > 2 && type === 'mrpml')
          exemptionFields.push('number_sites');
        if (value.length > 3) exemptionFields.push('number_sites');

        const siteExemptions = exemptionsValues[type]?.sites(
          value,
          null,
          values,
          codesNaf,
          supplier
        );
        if (siteExemptions?.surface) {
          exemptionFields.push('sites');
        }
        if (siteExemptions?.postcode) {
          exemptionFields.push('postcode');
        }
        if (siteExemptions?.exclusion) {
          exemptionFields.push(EXCLUSION_EXEMPTION_ITEM);
        }
      }
      if (fieldName === 'activities') {
        if (value.length > 10 || (supplier === 'ml' && value.length > 5)) {
          exemptionFields.push('activities');
        } else {
          value.forEach((activityName) => {
            const activity = codesNaf?.find(
              (act) => act.name.trim() === activityName.split('-')[0].trim()
            );
            if (activity?.derogatory_activity) {
              exemptionFields.push('derogatory_activity');
            }
          });
        }
      }
      if (
        type === 'association' &&
        fieldName === 'activities' &&
        value.length > 5
      ) {
        exemptionFields.push('activities');
      }
      if (fieldName === 'activity_detail' && value.length > 10) {
        exemptionFields.push('activity_detail');
      }
    } else if (
      fieldName === 'termination_reason_by_company' &&
      value !== 'TERMINATION_NO_PAYMENT' &&
      value !== undefined
    ) {
      exemptionFields.push(`termination_by_company`);
    } else if (fieldName === 'customer') {
      const customerExemptionData =
        exemptionsValues[type]?.customer?.(value, codesNaf, supplier) || {};

      Object.entries(customerExemptionData).forEach(([key, value]) => {
        if (value) exemptionFields.push(key);
      });
    } else if (
      exemptionsValues[type] &&
      exemptionsValues[type][fieldName] &&
      exemptionsValues[type][fieldName](
        value,
        initialContractValues?.[fieldName],
        values,
        codesNaf,
        supplier,
        estimation,
        activitiesHiscox
      )
    ) {
      exemptionFields.push(fieldName);
    }
  });

  if (estimation?.error?.forced_exemptions) {
    if (Array.isArray(estimation.error.forced_exemptions)) {
      exemptionFields.push(...estimation.error.forced_exemptions);
    } else if (typeof estimation.error.forced_exemptions === 'string') {
      exemptionFields.push(estimation.error.forced_exemptions);
    }
  }

  if (errorGetCities || errorGetQPV) {
    exemptionFields.push('city');
  }
  if (isQPV) {
    exemptionFields.push('qpv');
  }

  return exemptionFields;
};

export default checkExemption;
